export default {
    READY: 1,
    INBOUND:2,
    WRAP_UP: 3,
    NOT_READY: 4,
    OUTBOUND: 5,
    UNREACHABLE: 6,
};
